module.exports = __webpack_public_path__ + "img/6.2ff52af7.png";